import {createGlobalStyle} from 'styled-components'
import BG from 'assets/img/BG.png';
import BGx2 from 'assets/img/BG@2x.png';

const GlobalStyle = createGlobalStyle`

/* http://meyerweb.com/eric/tools/css/reset/ 
   v2.0 | 20110126
   License: none (public domain)
*/

html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed, 
  figure, figcaption, footer, header, hgroup, 
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video, button {
    margin: 0;
    padding: 0;
    border: 0;
    font: inherit;
    vertical-align: baseline;
    outline:none;
  }
  /* HTML5 display-role reset for older browsers */
  article, aside, details, figcaption, figure, 
  footer, header, hgroup, menu, nav, section {
    display: block;
  }
  body {
    line-height: 1;
  }
  a {
    text-decoration:none;
  }
  ol, ul {
    list-style: none;
  }
  blockquote, q {
    quotes: none;
  }
  blockquote:before, blockquote:after,
  q:before, q:after {
    content: '';
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  html,body {
    font-size:12px;
  }

  * {
    box-sizing:border-box;
  }

  button, label {
    cursor: pointer;
  }
  
  .msg-main {
    text-align: center;
  }

  .msg-caption {
    text-align: center;
  }

  .logo-img {
    display: block;
    margin: 0 auto;
    width: 75%;
  }
  
  ::-webkit-scrollbar {
    width: 0.5em;
    height: 0.5em;
  }
  // ::-webkit-scrollbar-button {
  //   width: 0.5em;
  //   height: 0.5em;
  // }
  ::-webkit-scrollbar-thumb {
    background: #474747;
    border: 0px none #ffffff;
    border-radius: 50px;
  }
  // ::-webkit-scrollbar-thumb:hover {
  //   background: #ffffff;
  // }
  // ::-webkit-scrollbar-thumb:active {
  //   background: #666;
  // }
  // ::-webkit-scrollbar-track {
  //   background: #ccc;
  //   border: 0px none #ffffff;
  //   border-radius: 0.5em;
  // }
  // ::-webkit-scrollbar-track:hover {
  //   background: #aaa;
  // }
  // ::-webkit-scrollbar-track:active {
  //   background: #999;
  // }
  ::-webkit-scrollbar-corner {
    background: transparent;
  }
  
  //** basic fade transition */
  .fade-enter {
    opacity: 0.01;
  }
  .fade-enter-active {
    /* opacity: 0.01; */
  }
  .fade-enter-done {
    opacity:1; 
    transition: opacity 500ms linear;
  }
  .fade-exit {
    opacity:1;
  }
  .fade-exit-active {
    opacity: 0.01;
    transition: opacity 500ms linear;
  }
  
  .bg {
    background:url(${BG});
    background-size:cover;
    background-position:center;
  }
  
  //** for retina display */
  @media only screen and (min--moz-device-pixel-ratio: 2),
  only screen and (-o-min-device-pixel-ratio: 2/1),
  only screen and (-webkit-min-device-pixel-ratio: 2),
  only screen and (min-device-pixel-ratio: 2) {
    .bg {
      background:url(${BGx2});
      background-size: cover;
      background-position:center;
    }
  }

`;
export default GlobalStyle;